








































import axios from "axios";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class DocumentIndexPage extends Vue {
  private documents = [];

  private headers = [
    { text: "Status", width: "10px" },
    { text: "Name", value: "name", width: "420px" },
    { text: "Publishers", value: "publishers" },
    { text: "Publication date", value: "publication_date" },
    { text: "Conflict", value: "conflict" },
    { text: "Disaster", value: "disaster" },
    { text: "Development", value: "development" },
    { text: "Facts", value: "factsCount" },
    { text: "Assigned to", value: "assigned_to" },
    { text: "Actions", value: "name", sortable: false },
  ];

  async created() {
    await this.load();
  }

  async load() {
    try {
      let response = await axios.get("/psql/parking_lot_documents_view", {
        params: {
          or: "(status.eq.waiting,remainingfactsCount.gt.0)",
        },
      });
      this.documents = response.data;
      this.$toast.success("Documents loaded");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to load documents");
    }
  }

  // create() forward the users to prepopulated form (they may change their mind later)
  async create(id: number) {
    if (!!id) {
      this.$router.push(`/scaffold/documents/parking_lot/${id}`);
    }
  }

  async edit(id: number) {
    if (!!id) {
      this.$router.push(`/scaffold/documents/${id}`);
    }
  }

  // reject() rejects the document directly
  async reject(id: number) {
    try {
      let response = await axios.post("/psql/rpc/helix_reject_parking_lot_record", {
        pl_id: id,
      });
      // remove from the dataset
      this.documents = this.documents.filter(
        (document: any) => document.id !== id
      );
      this.$toast.success("Document rejected");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to reject document");
    }
  }

  documentStatusIcon(status: string) {
    switch (status) {
      case "waiting":
        return "access_time";
      case "rejected":
        return "cancel_presentation";
      case "imported":
        return "insert_drive_file";
      default:
        return "access_time";
    }
  }
}
